export const STAGING_APP_ORIGIN = "https://stage.app.buddy.hr";
export const PRODUCTION_APP_ORIGIN = "https://payroll.moorepay.co.uk";
export const ALLOWED_HANDOFF_ORIGINS = [STAGING_APP_ORIGIN, PRODUCTION_APP_ORIGIN];

export function isStagingHost(hostname = window.location.hostname) {
  return hostname.includes("stage") || hostname.includes("local") || hostname === "mp.buddy.hr";
}

export function appOrigin(hostname = window.location.hostname) {
  return isStagingHost(hostname) ? STAGING_APP_ORIGIN : PRODUCTION_APP_ORIGIN;
}

export function appUrl(path = "", hostname = window.location.hostname) {
  const normalised = path.startsWith("/") ? path : path ? `/${path}` : "";
  return `${appOrigin(hostname)}${normalised}`;
}
